module.exports = noop

// no operation
// null -> null
function noop() {}

// call noop to satisfy test cov suites
noop()



// WEBPACK FOOTER //
// ./~/noop2/index.js